// this rules is in this example below
// https://redux-form.com/7.3.0/examples/fieldlevelvalidation/
import { intl } from '../core/globalIntl';
import m from "moment";
var dt = m();
var today = dt.format("YYYYMMDD");

// 必須チェック
export const required = value => (value ? (value.trim() ? undefined : intl.formatMessage({ id: 'inputCheckMessage.required' })) : intl.formatMessage({ id: 'inputCheckMessage.required' }));
export const required2 = value => (value ? undefined : intl.formatMessage({ id: 'inputCheckMessage.required2' }));
export const required3 = value => (value ? undefined : intl.formatMessage({ id: 'inputCheckMessage.required3' }));

// 最大文字数チェック
export const maxLength = max => value =>
  value && value.length > max ? intl.formatMessage({ id: 'inputCheckMessage.max' }, { max: max }) : undefined;

// 最少文字数チェック
export const minLength = min => value =>
  value && value.length < min ? intl.formatMessage({ id: 'inputCheckMessage.min' }, { min: min }) : undefined;

// 数字チェック
export const number = value =>
  value && !value.match(/^[0-9]+$/) ? intl.formatMessage({ id: 'inputCheckMessage.number' }) : undefined; // eslint-disable-line no-restricted-globals

export const minValue = min => value =>
  value && value < min ? `Must be at least ${min}` : undefined;

// メールアドレス形式チェック
export const email = value =>
  value && !/^[A-Z0-9.!#$%&'*/=?^_+-`{|}~]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value) ?
  intl.formatMessage({ id: 'inputCheckMessage.mailaddress' }) :
  undefined;

// メールアドレスドメインチェック()
export const emailDomain = value => 
  value && (/^[A-Z0-9.!#$%&'*/=?^_+-`{|}~]+@(?=.*-\.).*$/i.test(value) || /^[A-Z0-9._%+-]+@(?=.*\.-).*$/i.test(value)) ?
  intl.formatMessage({ id: 'inputCheckMessage.mailaddress' }) :
  undefined;
  
export const alphaNumeric = value =>
  value && /[^a-zA-Z0-9 ]/i.test(value) ?
  'Only alphanumeric characters' :
  undefined;

export const alphabet = value =>
  value && /[^a-zA-Z ]/i.test(value) ?
  '半角英字で入力してください。' :
  undefined;

export const kana = value =>
  value && /[^ア-ン゛゜ァ-ォャ-ョ ]/i.test(value) ?
  '全角カナで入力してください。' :
  undefined;

// 全角文字チェック
export const fullWidth = value =>
  !value ? undefined : (value && value.match(/^[^\x01-\x7E\uFF61-\uFF9F]+$/) ?
    undefined :
    intl.formatMessage({ id: 'inputCheckMessage.fullchar' }));

// 全角文字チェック(スペース不可)
export const fullWidthWithoutSpace = value =>
  !value ? undefined : (value && value.match(/^[^\x01-\x7E\uFF61-\uFF9F　]+$/) ?
    undefined :
    intl.formatMessage({ id: 'inputCheckMessage.fullchar' }));
    
// パスワード形式チェック
export const password = value =>
  value && (!value.match(/[A-Z]/) || !value.match(/[a-z]/) || !value.match(/\d/))?
  intl.formatMessage({ id: 'inputCheckMessage.password' }) :
  undefined;

// 確認用パスワードチェック
export const passwordConfirm = password => value =>
  value && value !== password ? intl.formatMessage({ id: 'inputCheckMessage.passwordConfirm' }) : undefined;

// 全角カタカナチェック(全角スペースと全角ハイフンもOK)
export const fullKanaWidth = value =>
  !value ? undefined : (value && value.match(/^[ァ-ヶー　]+$/) ?
    undefined :
    intl.formatMessage({ id: 'inputCheckMessage.fullKanachar' }));

// 全角カタカナチェック(全角スペースNGで全角ハイフンOK)
export const fullKanaWidthWithoutSpace = value =>
  !value ? undefined : (value && value.match(/^[ァ-ヶー]+$/) ?
    undefined :
    intl.formatMessage({ id: 'inputCheckMessage.fullKanachar' }));
    

// 電話番号チェック(先頭は必ず０、ハイフンは少なくとも１つは入る)
export const telephone = value =>
  !value ? undefined : (value && value.match(/^0[0-9]+-[0-9-]*[0-9]+$/) ?
    undefined:
    intl.formatMessage({ id: 'inputCheckMessage.telephone' }));
    
// 過去日付チェック(システム日付当日はOK)
export const pastDate = value => 
  !value ? undefined : (value && today > value) ? intl.formatMessage({ id: 'inputCheckMessage.pastdays' }) : undefined ;

// 日付妥当性チェック
export const correctDate = fromVal => value =>
  !fromVal || fromVal === "" ? undefined : fromVal <= value ? undefined : intl.formatMessage({ id: 'inputCheckMessage.wrongday' });

/************************************************************************************
 * 追加メソッド
 ************************************************************************************/  

// 電柱番号必須チェック
export const requiredPoleNo = (value) => {
  if (!value || !value.trim()) {
    return intl.formatMessage({ id: 'inputCheckMessage.poleNo.required' });
  }
  return '';
}

// 日付必須チェック
export const requiredDate = (value) => {
  console.log("value:" + value);
  if (!value || !value.trim()) {
    return intl.formatMessage({ id: 'inputCheckMessage.required' });
  }
  return '';
}

// 過去日付チェック(システム日付当日はOK)
export const oldDate = (value) => {
  if (value) {
    let valDate = m(value).format("YYYYMMDD");
    if (Number(today) > Number(valDate)) {
      return intl.formatMessage({ id: 'inputCheckMessage.pastdays' });
    }
  }
  return '';
}

// 日付形式チェック
export const dateLength = (value) => {
  let retValue = '';
  if (value && value.length !== 10) {
    retValue = intl.formatMessage({ id: 'inputCheckMessage.date.length' })
  }
  return retValue;
}
